import React, { Component } from 'react';
import { View, Animated, Dimensions, Platform, StatusBar } from 'react-native';

import { get as _get } from 'lodash';

import {
  isIPhoneDeviceWithNotch,
  isAndroidDeviceWithNotch,
} from '@vfgroup-oneplatform/foundation/Utils/Platform';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import TobiModal from '../Components/TobiModal';
import { TRAY_TYPES } from '../Utils/TrayTypesConstants';

import TrayWrapper from './TrayWrapper';
import styles from './withTray.Styles';
import { defaultNormalTrayHeight } from './withTrayHelper';

const { height } = Dimensions.get('window');
const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

const withTray = (WrapperScreen, configuration = {}) => {
  return class WrapperClass extends Component {
    state = {
      config: null,
      visable: true,
      type: TRAY_TYPES.MAIN,
      currentTray: TRAY_TYPES.MAIN,
      dropTray: false,
      trayHeight: configuration.normalTrayHeight || defaultNormalTrayHeight,
    };

    componentDidUpdate(_prevProps, prevState) {
      if (
        prevState.type === TRAY_TYPES.MAIN &&
        this.state.type === TRAY_TYPES.SECONDLEVEL &&
        this.state.visable
      ) {
        this.setState({ dropTray: true, upTray: false });
      } else if (
        prevState.type === TRAY_TYPES.SECONDLEVEL &&
        this.state.type === TRAY_TYPES.MAIN &&
        this.state.visable
      ) {
        this.setState({ upTray: true, dropTray: false }, () => {
          this.onSecondLevelScreenUnmount();
        });
      }

      // clearing tray modal if open
      if (prevState.visable !== this.state.visable) {
        const clearModal = _get(this.state, `config[${TRAY_TYPES.MAIN}].toggleModal`, () => null);
        clearModal(false);
      }
    }

    onSecondLevelScreenUnmount = () => {
      const notififcations = _get(this.state, 'config.secondLevel.notifications.length', 0);
      notififcations > 0 &&
        this.setState({
          config: {
            ...this.state.config,
            secondLevel: {
              ...this.state.config.secondLevel,
              notifications: [],
            },
          },
        });
    };

    showModal = (withTobi = true, translateY = new Animated.ValueXY(0), onHide = () => null) => {
      this.translateY = translateY;
      this.onHide = onHide;
      const ponit = Platform.select({
        ios: {
          y: (isIPhoneWithNotch ? 187 : 180) - height,
        },
        android: {
          y: (isAndroidDeviceWithNotch() ? 210 - StatusBar.currentHeight : 205) - height,
        },
      });
      if (!withTobi) {
        Animated.timing(translateY, {
          toValue: { x: 0, y: ponit.y },
          duration: 440,
          useNativeDriver: false,
        }).start();
      }
      this.modal.showModal(withTobi);
    };

    hideModal = (withTobi = false) => {
      if (!withTobi) {
        Animated.timing(this.translateY, {
          toValue: { x: 0, y: 0 },
          duration: 500,
          useNativeDriver: false,
        }).start(() => this.onHide());
      }
      this.modal.hideModal(withTobi, this.onHide);
    };
    hideModalInView = (withTobi = false) => {
      this.modal.hideModal(withTobi, this.onHide);
    };

    setTrayType = type => {
      this.setState({ type });
    };

    setTrayVisable = visable => {
      this.setState({ visable });
    };

    setTrayHeight = trayHeight => {
      this.setState({ trayHeight });
    };

    setTrayConfig = (type, config, rest) => {
      const newConfig = { ...this.state.config };
      newConfig[type] = rest ? config : { ..._get(this.state, `config[${type}]`, {}), ...config };
      this.setState({ config: newConfig });
    };

    setDropTray = value => {
      this.setState({ dropTray: value });
    };

    render() {
      const { config, visable, dropTray, upTray, currentTray, type } = this.state;
      const { renderTobiModal: RenderTobiModal = () => null, trayIcon = null } = config
        ? config[currentTray]
        : {};
      const { trayViewContainerStyle } = config ? config[type] : {};
      return (
        <View style={styles.container(type)} testID={FrameworkTestKeys.withTrayView}>
          <WrapperScreen
            {...this.props}
            isTrayVisable={visable}
            setTrayConfig={this.setTrayConfig}
            setTrayVisable={this.setTrayVisable}
            setTrayType={this.setTrayType}
            setTrayHeight={this.setTrayHeight.bind(this)}
          />

          <View
            style={[styles.trayViewContainer, trayViewContainerStyle]}
            pointerEvents="box-none"
            testID={FrameworkTestKeys.withTrayContainerView}
          >
            {config && visable && (
              <TrayWrapper
                trayType={this.state.type}
                trayView={configuration.trayView}
                {...config[TRAY_TYPES.SECONDLEVEL]}
                {...config[TRAY_TYPES.MAIN]}
                trayHeight={this.state.trayHeight}
                dropTray={dropTray}
                upTray={upTray}
                setDropTray={this.setDropTray}
                showModal={this.showModal}
                hideModal={this.hideModal}
                setTrayHeight={this.setTrayHeight.bind(this)}
              />
            )}
          </View>
          <TobiModal
            ref={obj => {
              this.modal = obj;
            }}
            onHideModal={this.hideModal}
            trayIcon={trayIcon}
            trayType={this.state.type}
          >
            <RenderTobiModal hideTobiModal={this.hideModalInView} />
          </TobiModal>
        </View>
      );
    }
  };
};

export default withTray;
